import React from 'react'
import List from './list'
import Stack from '@mui/material/Stack'
import VendorPicker  from '../../components/vendorPicker'
const ExtraCosts = () => {
  return (
    <Stack
      direction="column"
      justifyContent="space-evenly"
      alignItems="center"
      spacing={2}
    >
      <VendorPicker/>
      <List/>
    </Stack>
  )
}

export default ExtraCosts;